export default "__VITE_ASSET__CEoEZypg__"